<template>
  <div class="order-list-wrap">
    <ul class="order-list">
      <order-item
        v-for="(order, index) in orders"
        :key="index"
        :order="order"
        @choosed="toDetail(order.orderNum)"></order-item>
    </ul>
    <infinite-loading @infinite="infiniteHandler" ref="infinite">
      <span slot="no-more">
        {{ $t('withoutMore') }} :(
      </span>
      <div slot="no-results">
        <no-order-result @action="$emit('action')"></no-order-result>
      </div>
    </infinite-loading>
  </div>

</template>

<script type="text/javascript">
import OrderItem from './order-item';
import noOrderResult from '@/core/order-list/no-result';
import { getOrderList } from '@/apis/base';
import InfiniteLoading from 'vue-infinite-loading';

const FIRST_INDEX = '1';
export default {
  components: {
    InfiniteLoading,
    noOrderResult,
    OrderItem
  },
  data () {
    return {
      pageInfo: {},
      orders: []
    };
  },
  // computed: {
  //   orderList () {
  //     return this.$store.state.order.orderList;
  //   }
  // },
  props: {
    infiniteLoad: {
      type: Boolean,
      default: true
    },
    q: String,
    type: String
  },
  watch: {
    q () {
      this.infiniteHandler(this.$refs.infinite.stateChanger, FIRST_INDEX);
    },
    type () {
      this.infiniteHandler(this.$refs.infinite.stateChanger, FIRST_INDEX);
    }
  },
  methods: {
    toDetail (orderId) {
      this.$emit('choosed', orderId);
    },
    infiniteHandler ($sta, initPage) {
      const requestPage = initPage || +this.pageInfo.pageIndex + 1 || FIRST_INDEX;

      getOrderList(requestPage, 10, this.q, this.type).then(res => {
        if (!res || +res._errCode !== 0) {
          $sta.complete();
          return;
        }

        if (initPage) {
          this.orders = res._data.orderList;
        } else {
          this.orders = this.orders.concat(res._data.orderList);
        }
        this.pageInfo = res._data.pageInfo;

        if (this.orders.length) {
          $sta.loaded();
        }

        if (requestPage >= this.pageInfo.totalPage) {
          $sta.complete();
          // return;
        }
      }).catch(() => {
        $sta.complete();
      });
    }
  }
};
</script>
